import { useCallback, useState } from "react";
import ReactDropdown from "react-dropdown";
import { MarketDropdown } from "../Dropdown/MarketDropdown";
import { Button, ButtonThemeEnum } from "../shared/Buttons/styles";
import Checkbox from "../shared/Checkbox";
import { CheckboxContainer } from "../shared/Checkbox/style";
import { FilterWrapper, TradesWrapper } from "./style";
import InstrumentChart from "./InstrumentChart";
import { INTERNAL_PERPS_SHORT_ADDRESS, INTERNAL_PERPS_LONG_ADDRESS, INTERNAL_OPTIONS_ADDRESS } from "../../constants/admin";

const STRATEGY_OPTIONS = [
  { label: "Perp", value: "perp" },
  { label: "Options", value: "options" },
];

export function MMTrades() {
  const [asset, setAsset] = useState<string>();
  const [strategy, setStrategy] = useState<string>("perp");
  const [showAllTrades, setShowAllTrades] = useState(false);
  const [fetchParams, setFetchParams] = useState<{
    asset?: string;
    strategy?: string;
    showAllTrades: boolean;
  }>({ strategy: "perp", showAllTrades: false });
  const [fetchKey, setFetchKey] = useState<number>(0);

  const handleFetch = useCallback(() => {
    setFetchParams({
      asset,
      strategy,
      showAllTrades,
    });
    setFetchKey((prevKey) => prevKey + 1);
  }, [asset, strategy, showAllTrades]);

  // Determine which accounts to use based on strategy
  const getAccountsForStrategy = (selectedStrategy?: string): string[] => {
    if (selectedStrategy === "perp") {
      return [INTERNAL_PERPS_SHORT_ADDRESS, INTERNAL_PERPS_LONG_ADDRESS];
    } if (selectedStrategy === "options") {
      return [INTERNAL_OPTIONS_ADDRESS];
    }
    return [];
  };

  const accounts = getAccountsForStrategy(fetchParams.strategy);

  return (
    <TradesWrapper>
      <FilterWrapper>
        <MarketDropdown onClick={setAsset} overridePlaceholder="Select Asset" />
        <ReactDropdown
          className="dropdown"
          menuClassName="dropdown-menu"
          placeholderClassName="dropdown-placeholder"
          options={STRATEGY_OPTIONS}
          onChange={(selectedOption) => setStrategy(selectedOption.value)}
          placeholder="Select Strategy"
          value={strategy}
        />
        <CheckboxContainer>
          <Checkbox
            checked={showAllTrades}
            onToggle={() => setShowAllTrades(!showAllTrades)}
            title="All Trades"
          />
        </CheckboxContainer>
        <Button
          buttonTheme={ButtonThemeEnum.NEUTRAL2}
          disabled={!asset}
          onClick={handleFetch}
          style={{ minHeight: 24, maxHeight: 24 }}
        >
          Fetch
        </Button>
      </FilterWrapper>
      {fetchParams.asset && accounts.map((account) => (
        <InstrumentChart
          key={`${fetchKey}-${fetchParams.asset}-${account}-${fetchParams.showAllTrades}`}
          asset={fetchParams.asset!}
          showAllTrades={fetchParams.showAllTrades}
          account={account}
          strategy={fetchParams.strategy}
        />
      ))}
    </TradesWrapper>
  );
}
